import styled, { createGlobalStyle } from 'styled-components'
import { Header } from 'components/Header'
import { respondTo } from '@careguide/theme'
import { Layout } from 'types/careguide-page'

const InboxPageLayout: Layout = ({ children, loggedIn, hasUpgradeCta }) => {
  return (
    <>
      <GlobalStyle />
      <Header loggedIn={!!loggedIn} showUpgradeCta={!!hasUpgradeCta} />
      <Main>{children}</Main>
    </>
  )
}

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    min-height: 100%;
  }

  #__next {
    height: 100%;
    min-height: 100%;
  }
`

const Main = styled.main`
  height: calc(100% - 48px);
  overflow: auto;

  ${respondTo.desktop`
    height: calc(100% - 82px);
  `}
`

export default InboxPageLayout
